var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconGlass = function SvgIconGlass(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;opacity:0;}.b{fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-938 -784)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M136,255H96v40h40Z",
    transform: "translate(842 529)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.923,274.784a1,1,0,0,1,0,1.414l-2.228,2.228a1,1,0,1,1-1.414-1.414l2.228-2.228A1,1,0,0,1,113.923,274.784Z",
    transform: "translate(842 529)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M104,264a1,1,0,0,1,1-1h22a1,1,0,0,1,1,1v22a1,1,0,0,1-1,1H105a1,1,0,0,1-1-1Zm2,15.561V285h20v-9.838l-5.969,6.133A1,1,0,1,1,118.6,279.9l7.056-7.251a.986.986,0,0,1,.346-.232V269.39l-3.806,3.806a1,1,0,0,1-1.414-1.414l5-5a1,1,0,0,1,.22-.167V265H106v11.847l3.379-3.379a1,1,0,0,1,1.414,1.414l-4.457,4.457A1,1,0,0,1,106,279.561Z",
    transform: "translate(842 529)"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconGlass, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-glass.ae22dba9.svg";
export { ForwardRef as ReactComponent };